export default "__VITE_ASSET__YmlCOzoK__"